export const ANALYTICS_ENV = {
  LOCAL: 'local',
  STAGING: 'staging',
  PRODUCTION: 'production',
} as const;

export type AnalyticsEnvironment = typeof ANALYTICS_ENV[keyof typeof ANALYTICS_ENV];

/** Non-prod base domains that route to the test API and must not be tracked. */
const STAGING_DOMAINS = ['meitre-test.com', 'meitre-staging.com'];

/** Match a base domain or any of its subdomains (e.g. "crizia.meitre-test.com"). */
function matchesDomain(hostname: string, base: string): boolean {
  return hostname === base || hostname.endsWith(`.${base}`);
}

/**
 * Detect analytics environment based on hostname.
 * - localhost / 127.0.0.1 → local (console.log only)
 * - *.meitre-test.com / *.meitre-staging.com → staging (silent, no tracking)
 * - everything else → production (full tracking)
 */
export function getAnalyticsEnvironment(): AnalyticsEnvironment {
  const hostname = window.location.hostname;

  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return ANALYTICS_ENV.LOCAL;
  }

  if (STAGING_DOMAINS.some((base) => matchesDomain(hostname, base))) {
    return ANALYTICS_ENV.STAGING;
  }

  return ANALYTICS_ENV.PRODUCTION;
}
